module.exports = __webpack_public_path__ + "img/16.59a6ce8d.jpg";